import type { AppModule } from '@/app/app-module.types';
import { ContentIcon } from '@/shared/icons';
import { CONTENT_ROLES } from '@/shared/guards/roles';
import { contentContainer } from './di/container';
import { ContentRepositoryToken } from './di/tokens';
import { contentRoutes } from './presentation/routes';

/**
 * Módulo de Conteúdo (= ContentModule no monolith): content items, assuntos,
 * visões e o grafo de classificação. Consome `/admin/content/*`. Exclusivo do
 * admin — aparece no grupo "Gerenciamento" da sidebar.
 */
export const contentModule: AppModule = {
  name: 'content',

  register(container) {
    container.register(
      ContentRepositoryToken,
      () => contentContainer.repository,
    );
  },

  routes: contentRoutes,

  menu: [
    {
      label: 'Conteúdo',
      to: '/content',
      icon: ContentIcon,
      section: 'registry',
      order: 3,
      roles: CONTENT_ROLES,
    },
  ],
};
